export const productNames = {
	WAC: 'marketing',
};

// https://hello.atlassian.net/wiki/spaces/POSTOFFICE/pages/4954887423/Project+poster+Encourage+comment+response+in+Confluence+with+flags
export const COMMENT_NUDGE_EXP_TAP_AUDIENCE_ID =
	'segment_confluence_mau_not_mcu_with_user_tenure_greater_than_90_days_siteuser';

export const PAYING_SITES_LESS_THAN_TWO_MONTHS_OLD_TAP_AUDIENCE_ID =
	'segment_paying_sites_less_than_2_months_old_siteid';

export const PARTNER_MANAGED_TENANTS_TAP_AUDIENCE_ID = 'segment_partner_managed_tenants_siteid';
// https://data-portal.internal.atlassian.com/targeting/registry/c3efe656-ed40-4350-90f4-d8fb9d6b6eab
export const JIRA_ASSIGNED_NUDGE_EXP_TAP_AUDIENCE_ID =
	'segment_jira_recently_inactive_peu_non_mau_siteuser';
